<template>
  <div class="teamYJtable" v-loading="loadingTrue">
    <!-- 施工队和班组工队里得专项资质 -->
    <el-table
      :data="tableData"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-if="!loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt style="margin-bottom:10px;line-height:0px;margin-top:50px;width:100px"/>
        <p class="noText" style="color:#666666;fontSize:16px;line-height:30px;margin-bottom:50px">暂无数据</p>
      </template>
      <el-table-column  label="资质名称" prop="qualificationName" show-overflow-tooltip width="230">
        <template slot-scope="scope">
          <span>{{ scope.row.qualificationName||'/'}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="行业类型" prop="industryQualificationConfigName" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.industryQualificationConfigName||'/'}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="资质类型" prop="qualificationClassName" show-overflow-tooltip width="230">
        <template slot-scope="scope">
          <span>{{ scope.row.qualificationClassName||'/'}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="资质等级" prop="qualificationLevelName" width="230">
        <template slot-scope="scope">
          <span>{{ scope.row.qualificationLevelName||'/'}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="备案单位" prop="recordUnit" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.recordUnit||'/'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :param="param" @change="getTeamResultsList" v-if="tableData&&tableData.length" :loadingTrue="loadingTrue"></Pagination>
    <PerformanceDetailsModal ref="performanceDetailsModal"/>
  </div>
</template>

<script>
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
import { apiTeamDetail } from '@/api/apiTeamDetail'
import moment from "moment"
export default {
  data () {
    return {
      setColumnDataColor,
      setCellStyle,
      loadingTrue: false,
      tableData: [],
      param: {
        page: 1,
        limit: 20,
        teamNo: '',
        total: 0
      }
    }
  },
  props: {
    isGzbj: {
      type: Boolean,
      default:false
    },
    data:{
      type:Object
    }
  },
  components: {
    Pagination: () => import('@/views/Construction/components/Pagination'), // 分页
    PerformanceDetailsModal : ()=>import('./teamYJtable/PerformanceDetailsModal'), // 工程业绩详情弹窗
  },
  created () {
    this.getTeamResultsList()
  },
  methods: {
    formatDate(date){
      return moment(date).format('YYYY/MM/DD')
    },
    async getTeamResultsList () {
      this.loadingTrue = true
      if (this.$route.query.teamNo){
        this.param.teamNo = this.$route.query.teamNo
      } 
      let res = await apiTeamDetail.GetAptitudeList(this.param)
      if (res.data.code === 200) {
        this.tableData = res.data.data.records
        this.param.total = res.data.data.total
        this.loadingTrue = false
      } else {
        this.loadingTrue = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-table__empty-text{
  line-height: 0px;

}
 .text_ellipsis {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
 }
 /deep/.cell{
   padding: 0 20px !important;
 }
 /deep/td{
   height: 44px !important;
 }
 /deep/th{
   height: 44px !important;
   padding: 10px 0 !important;
 }
</style>
